<template>
  <a-spin :spinning="confirmLoading">
    <div>
      <a-form :form="form" slot="detail">
        <div class="Section0" style="layout-grid:15.6000pt;">
          <p class=MsoNormal align=center style="margin-bottom:7.8000pt;mso-para-margin-bottom:0.5000gd;mso-pagination:none;text-align:center;mso-line-height-alt:12pt;">
            <b>
				<span
          style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;mso-font-kerning:0.0000pt;">
					<font face="黑体">山东师范大学招标采购项目验收申请(备案)</font>
				</span>
            </b>
            <b>
				<span
          style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;mso-font-kerning:0.0000pt;">
					&nbsp;
				</span>
            </b>
          </p>
          <p class=MsoNormal align=center style="mso-pagination:none;text-align:center;mso-line-height-alt:12pt;">
            <span
              style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <b>
				<span
          style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-weight:bold;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">编号：{{ysbgNo}}</font>
				</span>
            </b>
            <b>
				<span
          style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-weight:bold;font-size:18.0000pt;mso-font-kerning:0.0000pt;">
					&nbsp;
				</span>
            </b>
          </p>

          <table class=MsoNormalTable align=center border=1 cellspacing=0
                 style="border-collapse:collapse;width:459.0000pt;mso-table-layout-alt:fixed;border:none;mso-border-left-alt:0.5000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;mso-border-insideh:0.5000pt solid windowtext;mso-border-insidev:0.5000pt solid windowtext;mso-padding-alt:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;">
            <tr style="height:22.7000pt;">
              <td width=134 valign=center colspan=2
                  style="width:90.75pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;width:80px;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">项目编号</span>

                </p>
              </td>
              <td width=245 valign=center colspan=2
                  style="width:147.4000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;">
						<span
              style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:11.0000pt;mso-font-kerning:0.0000pt;">
             {{model.contractNo}}
						</span>
                </p>
              </td>
              <td width=135 valign=center
                  style="width:81.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;width:80px;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">项目名称</span>

                </p>
              </td>
              <td width=249 valign=center
                  style="width:149.8500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;margin:10px 0;">
						<span
              style="line-height:16px;font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:11.0000pt;mso-font-kerning:0.0000pt;">
                {{model.budgetAddmainName}}
						</span>
                </p>
              </td>
            </tr>
            <tr style="height:22.7000pt;">
              <td width=134 valign=center colspan=2
                  style="width:80.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">中标单位</span>

                </p>
              </td>
              <td width=245 valign=center colspan=2
                  style="width:147.4000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;">
						<span
              style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:11.0000pt;mso-font-kerning:0.0000pt;">
						{{model.zbdw}}
						</span>
                </p>
              </td>
              <td width=135 valign=center
                  style="width:81.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">合同金额(万)</span>
                </p>
              </td>
              <td width=249 valign=center
                  style="width:149.8500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;">
						<span
              style="font-family:宋体;mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:11.0000pt;mso-font-kerning:0.0000pt;">
						{{model.zbPrice}}(本次验收金额:{{model.ysMoney}})
						</span>
                </p>
              </td>
            </tr>
            <tr style="height:22.7000pt;">
              <td width=134 valign=center colspan=2
                  style="width:80.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">项目类别</span>
                </p>
              </td>
              <td width=245 valign=center colspan=2
                  style="width:147.4000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
              <span
                style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:Arial;mso-bidi-font-family:Arial;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
             {{model.projectType}}
              </span>
                </p>
              </td>
              <td width=135 valign=center
                  style="width:81.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><font style="color:red">*</font>完工日期</span>

                </p>
              </td>
              <td width=249 valign=center
                  style="width:149.8500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                {{model.projectFinishtime}}
              </td>
            </tr>
            <tr style="height:22.7000pt;">
              <td width=134 valign=center colspan=2
                  style="width:80.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><font style="color:red">*</font>验收方式</span>
                  <span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							&nbsp;
						</span>
                </p>
              </td>
              <td width=245 valign=center colspan=2
                  style="width:147.4000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                {{yanshou.ysType=="1"?"自行验收":"委托验收"}}
              </td>
              <td width=135 valign=center
                  style="width:81.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:Arial;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;"><font style="color:red">*</font>验收日期</span>
                </p>
              </td>
              <td width=249 valign=center
                  style="width:149.8500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                {{model.acceptanceTime}}
              </td>
            </tr>


            <tr style="height:70.4500pt;page-break-inside:avoid;">
              <td width=78 valign=center
                  style="width:47.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal align=center style="text-align:center;line-height:12.0000pt;width:80px;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);letter-spacing:1.5000pt;font-size:12.0000pt;mso-font-kerning:14.0000pt;"><font style="color:red">*</font>验收内容</span>
                </p>
              </td>
              <td width=686 valign=top colspan=5
                  style="width:411.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                {{model.ysContent}}
<!--                <a-form-item style="margin: 0 !important;" label="">-->
<!--                  <p>验收内容附件(请将验收现场照片放到word/pdf/excel/zip/rar格式文件中上传)</p>-->
<!--                  {{model.bgsqb}}-->
<!--                </a-form-item>-->
                <p class=MsoNormal align=center style="text-align:left;">
                  <a-form-item>
                  <font style="color:red">*</font>发票金额(万元)：{{model.fbMoney}}
                  </a-form-item>
                </p>
              </td>
            </tr>
            <tr style="height:50.8000pt;" >
              <td width=63  valign=center  rowspan=3  style="width:47.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:none;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;" >
                <p class=MsoNormal  align=center  style="text-align:center;line-height:12.0000pt;width:80px;" >
                  <span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);letter-spacing:1.5000pt;
font-size:12.0000pt;mso-font-kerning:14.0000pt;" >
                    <font face="宋体" >项目负责单位验收意见</font>
                  </span>
                </p>
              </td>
              <td width=549  valign=top  colspan=5  style="width:411.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;" >
                <p class=MsoNormal  style="margin-top:10px;line-height:12.0000pt;" >
                  <span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;
mso-font-kerning:0.0000pt;" >
                    <font style="color:red">*</font><font face="宋体" >验收结论性意见：</font>
                  </span>
                </p>
                <p>
                  <a-form-item label="">
                    {{yanshouResult}}
                  </a-form-item>
                </p>
              </td>
            </tr>
            <tr style="height:69.5500pt;" >
              <td width=549  valign=top  colspan=5  style="width:411.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;" >
                <p class=MsoNormal  style="line-height:12.0000pt;" >
                  <span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;
mso-font-kerning:0.0000pt;" >
                    <font face="宋体" >有异议的意见和说明理由：</font>
                  </span><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);
font-size:12.0000pt;mso-font-kerning:0.0000pt;" >
                </span>
                </p>
                <p class=MsoNormal  style="text-indent:282.0000pt;mso-char-indent-count:23.5000;line-height:12.0000pt;" >
                    {{model.ysxzObjection}}
                </p>
              </td>
            </tr>
            <tr style="height:108.3500pt;" >
              <td width=549  valign=top  colspan=5  style="width:411.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;" >
                <p class=MsoNormal  style="line-height:12.0000pt;" >
                  <span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);
font-size:12.0000pt;mso-font-kerning:0.0000pt;" ></span>
                </p>
                <p class=MsoNormal  style="line-height:12.0000pt;" >
                  <span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;
mso-font-kerning:0.0000pt;" >
                    <font style="color:red">*</font>
                    <font face="宋体" >验收小组</font>
                    <font face="Times New Roman" >(</font>
                    <font face="宋体" >至少三人</font>
                    <font face="Times New Roman" >)</font>
                    <font face="宋体" >签字：</font>
                  </span>
                  <span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;
mso-font-kerning:0.0000pt;" >
                    <span v-if="sqbeian_chubuyanshou.showQrCodediv && genQcode">
                    </span>
                  </span>
                <div class="image-container" v-for="(item,i) in sqbeian_chubuyanshou.img">
                  <img   :src="item.elSign" style="width:180px"/>
                </div>

                <br>
                <p class=MsoNormal  style="line-height:12.0000pt;" >
                  <span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;
mso-font-kerning:0.0000pt;" >
                    <font style="color:red">*</font><font face="宋体" >项目负责人签字：</font>
                    <span v-if="sqbeian_chubuyanshouFuZheRen.showQrCodediv && genQcode">

                  </span>
                      <div class="image-container" v-for="(item,i) in sqbeian_chubuyanshouFuZheRen.img">
                  <img   :src="item.elSign" style="width:180px"/>
                </div>
                     <span style="font-family:'Times New Roman';mso-spacerun:'yes';" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <font face="宋体" >联系方式：</font>
                  </span>
                  <span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);
font-size:12.0000pt;mso-font-kerning:0.0000pt;" >{{sqbeian_chubuyanshouFuZheRen.phone}}</span>
                </p>
                <p class=MsoNormal  style="line-height:12.0000pt;" >
                  <span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);
font-size:12.0000pt;mso-font-kerning:0.0000pt;" ></span>
                </p>
                <p class=MsoNormal  style="line-height:12.0000pt;" >
                  <span style="font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';
mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;
mso-font-kerning:0.0000pt;" >
                    <br>
                    <font face="宋体" >单位负责人（签字）：</font>
                    <div style="margin:15px 50px">{{dwfzrqz}}</div>
                  </span>
                </p>

              </td>
            </tr>

            <tr style="height:34.7500pt;">
              <td width=765 valign=center colspan=6
                  style="width:459.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal style="line-height:12.0000pt;">
                  <span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">受邀质量、技术检测机构意见：</span>
                  <span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                    {{model.jsjcjgyj}}
                  </span>
                </p>
              </td>
            </tr>
            <tr style="height:54.3500pt;">
              <td width=378 valign=top colspan=3
                  style="width:227.2500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal>
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">履约验收科意见：</span>
                  <span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;mso-hansi-font-family:宋体;mso-bidi-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                    <div style="    height: 120px;
    text-align: center;
    letter-spacing: 8px;
    line-height: 113px;
    font-size: 24px;
    font-family: 宋体;">
             {{model.lyysIdea}}
                      </div>
						</span>
                </p>
                <!-- <p class=MsoNormal align=right style="mso-char-indent-count:5.0000;text-align:right;">
                   <span
                     style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">时间：</span>
                   <span
                     style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                     <a-form-item label="">
               &nbsp;							<a-input type="text" class="inputclass shurukuang" v-decorator="['lyysTime']" style="width: 100%;"/>
                     </a-form-item>

             </span>
                 </p>-->
              </td>
              <td width=386 valign=top colspan=3
                  style="width:231.7500pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:none;mso-border-left-alt:none;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <div style="position: relative;margin-bottom:10px;">
                  <p class=MsoNormal>
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">资产与实验室管理处负责人签字或盖章：</span>

                  </p>
                  <p class=MsoNormal style="margin-left:60px;margin-top:15px;">
                    <img style="width:130px"  :src="getAvatarView(zcglcfzr)"/>

                  </p>
                  <p class=MsoNormal style="margin-left:120px;margin-top:10px;">
                    <font
                      face="宋体" style="font-size:20px;color:black">{{zcglcfzrqzsj}}</font></p>

                  <div style="width: 90px;
    font-size: 12pt;
    position: absolute;
    left: 152px;
    top: 22px;
    font-family: 黑体;">
<!--                    <img lang="EN-US" style="width:120px;font-size:12.0pt;font-family:黑体;opacity:0.8" :src="getAvatarView(zcglcfzrgz)">-->
                  </div>

                </div>
              </td>
            </tr>
            <tr style="height:22.4500pt;">
              <td width=765 valign=center colspan=6
                  style="width:459.0000pt;padding:0.0000pt 5.4000pt 0.0000pt 5.4000pt ;border-left:1.0000pt solid windowtext;mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;border-top:none;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                <p class=MsoNormal style="line-height:12.0000pt;">
                  <span
                    style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">供应商确认（签字）：</span>
                  <span
                    style="font-family:'Times New Roman';mso-fareast-font-family:宋体;color:rgb(0,0,0);font-size:12.0000pt;mso-font-kerning:0.0000pt;">
                     <span v-if="sqbeian_GongYingShang.showQrCodediv && genQcode">

                    </span>
                    <div class="image-container" v-for="(item,i) in sqbeian_GongYingShang.img">
                  <img   :src="item.elSign" style="width:180px"/>
                </div>
					</span>
                </p>
              </td>
            </tr>
          </table>
          <p class=MsoNormal align="center" style="text-align: center;">
			<span
        style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:'Times New Roman';mso-hansi-font-family:'Times New Roman';mso-bidi-font-family:'Times New Roman';color:rgb(0,0,0);font-size:10.0000pt;mso-font-kerning:0.0000pt;">

			</span>
          </p>
        </div>
      </a-form>
    </div>
  </a-spin>
</template>

<script>
  import {httpAction, getAction} from '@/api/manage'
  import pick from 'lodash.pick'

  import moment from 'moment'

  //import { formatDate } from '@/utils/util'
  import dayjs from 'dayjs';
  export default {
    name: 'UapsBudgetAddmainForm',
    components: {},
    props: {
      genQcode:{
        type:Boolean,
        default:false
      },
      //流程表单data
      formData: {
        type: Object,
        default: () => {
        },
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        showQrCode:false,
        domain:window.location.host,
        qrcodeText:'',
        qrcodeTitle:'',
        yanshou: {},
        yanshouOptions: [{value: '1', label: '自行验收'}, {value: '2', label: '委托验收'}],
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        confirmLoading: false,
        packageId: '',
        ysbgNo:'',
        validatorRules: {
          ysType: {
            rules: [
              {required: true, message: '请选择验收方式'},
            ]
          },
          acceptanceTime: {
            rules: [
              {required: true, message: '请选择验收日期'},
            ]
          },
          ysContent: {
            rules: [
              {required: true, message: '请填写验收内容'},
            ]
          },
          ysxzIdea: {
            rules: [
              {required: true, message: '请选择验收小组结论性意见'},
            ]
          },
          hasImport: {
            rules: [
              {required: true, message: '请选择有无进出口设备'},
            ]
          },
          bgsqb: {
            rules: [
              {required: true, message: '请上传验收内容附件'},
            ],
          },
          fbMoney: {
            rules: [
              {required: true, message: '请输入发票金额'},
            ]
          },
          acceptanceETime:{
            rules: [
              {required: true, message: '请选择完工日期'},
            ]
          }
        },
        ysContentDefMsg:"",
        //项目执行单位初步验收意见 初验人员(需三人)签字
        sqbeian_chubuyanshou:{
          name:[],
          nameNum:3,//签名个数
          phone:"",
          msg:"",
          qrtitle:"初验人员签字",
          qrtext:"",
          field:"sqbeian_chuyan",
          showQrCodediv:true,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        //项目执行单位初步验收意见 项目负责人签字
        sqbeian_chubuyanshouFuZheRen:{
          name:[],
          nameNum:1,//签名个数
          phone:"",
          msg:"",
          qrtitle:"项目负责人签字",
          qrtext:"",
          field:"sqbeian_chuyanFuZheRen",
          showQrCodediv:true,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        //项目执行单位初步验收意见 单位负责人签字
        sqbeian_cyDanWeiFuZheRen:{
          name:[],
          nameNum:1,//签名个数
          phone:"",
          msg:"",
          qrtitle:"单位负责人签字",
          qrtext:"",
          field:"sqbeian_chuyanDanWeiFuZheRen",
          showQrCodediv:false,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        //资产处负责人签字
        sqbeian_zichanchuFuZheRen:{
          name:[],
          nameNum:1,//签名个数
          phone:"",
          msg:"",
          qrtitle:"资产处负责人签字",
          qrtext:"",
          field:"sqbeian_zichanchuFuZheRen",
          showQrCodediv:true,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        //供应商签字
        sqbeian_GongYingShang:{
          name:[],
          nameNum:1,//签名个数
          phone:"",
          msg:"",
          qrtitle:"供应商确认签字",
          qrtext:"",
          field:"sqbeian_GongYingShang",
          showQrCodediv:true,
          showQrCode:false,
          createTime:null,
          img:[]
        },
        fileIds: '',
        dwfzrqz:'',
        zcglcfzr:'',
        zcglcfzrqz:'',
        lyyskyj:'',
        zcglcfzrqzsj:'',
        tableId: '',
        orgCode:'',
        accId:'0',
        yanshouResult:'',
        planId:'',
        flowTitle:'履约验收备案申请审核',//流程title
        SignCompleteText:'',//未完成签名提示信息
        enableFinshDate:false,//完工日期是否填写完成
        signArray_Jiandu:[],//监督人员签名
        contractTime:null,//合同签订日期
        isSave:false,//是否保存数据
        url: {
          add: "/uaps_project_acceptance/uapsProjectAcceptance/add2",
          edit: "/uaps_project_acceptance/uapsProjectAcceptance/editYSBG",
          queryById: "/uaps_budget_addmain/uapsBudgetAddmain/queryById"
        }
      }
    },
    computed: {
      formDisabled() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return true
          }
        }
        return false
      }
    },
    created() {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
      let that=this;
      setTimeout(function() {
        that.getDataById();
      },500);
    },
    methods: {
      getSignImg: function (avatar) {
        if(avatar.name.length>0){
          return getFileAccessHttpUrl(avatar.name[0].sign);
        }
        return null;
      },
      getGZImg: function (avatar) {
        if(avatar.name.length>0){
          return {background: 'url(' + getFileAccessHttpUrl(avatar.name[0].GZ) + ')  98% -53% / 150px no-repeat',height:'160px'};
        }
        return null;
      },
      getSignTime: function (avatar) {
        if(avatar.name.length>0){
          return avatar.name[0].time;
        }
        return null;
      },
      changeFinshDate(val)
      {
        this.enableFinshDate=true;

      },
      disabledWangongDate(val){
        //完工日期 在签订合同之后，当前时间之前 限制
        let contractBjTime=moment(this.contractTime).format('YYYY-MM-DD');
        // return val <= moment(contractBjTime, 'YYYY-MM-DD').add(-1, 'days').endOf('day') || val > moment().endOf('day')
        return val >= moment().add(1, 'days').startOf('day')
      },
      disabledYanShouDate(val){
        //验收日期时间设置
        let finishDate=this.form.getFieldValue('projectFinishtime');

        //return val < moment(finishDate, 'YYYY-MM-DD').endOf('day') || val > moment().endOf('day')
        return val < moment(finishDate, 'YYYY-MM-DD').add(-1, 'days').endOf('day')
      },

      // 导出word方法
      exportWordFile() {
        let params = {
          planId : this.planId,packageId:this.packageId,id:this.accId,orgCode:this.orgCode
        };
        downloadFile('/uaps_project_acceptance/uapsProjectAcceptance/exportWordSqBeian', "山东师范大学招标采购项目验收申请(备案).docx",params);
      },
      //生成二维码
      QrCode_shenqing(obj){

        //已经保存过数据，直接生成二维码
        if(this.isSave){
          let qrcodetxt='/expertConfirmInfo?infoType=applybeian&accId='+this.accId+'&orgCode='+this.orgCode+'&planId='+this.planId+'&packageId='+this.packageId+'&id='+this.tableId+'&field='+obj.field;
          let time = parseInt(new Date().getTime() / 1000);
          obj.qrtext='http://'+this.domain+qrcodetxt+'&time='+time;
          obj.showQrCode=true;
        }
        else{
          const that = this;
          // 触发表单验证,数据项必须填写完整，才能生成二维码，否则查看二维码信息内容为空
          this.form.validateFields((err, values) => {
            if (!err) {
              var projectFinishtime = Date.parse(values.projectFinishtime);

              var acceptanceTime = Date.parse(values.acceptanceTime);
              if(acceptanceTime<projectFinishtime){
                that.$message.error("验收日期必须在完工日期之后,请查看");
              }
              if(values.ysxzIdea!='1'){
                that.$message.error("验收结论性意见 非合格 不允许发起流程");
              }
              else{
                that.confirmLoading = true;
                let httpurl = '';
                let method = '';
                httpurl += that.url.add;
                method = 'post';
                let formData = Object.assign(that.model, values);
                formData.isBa='1'
                formData.packageNo = that.packageId;
                formData.id=that.accId;
                httpAction(httpurl, formData, method).then((res) => {
                  if (!res.success) {
                    // //是否需要上传
                    // let chyanneedup="&needup=1";
                    // //初验一人已经上传过图片或视频，后续人签名就不需要进行上传了
                    // if(obj.field=="sqbeian_chuyan"){
                    //   if(obj.name.length>0){
                    //     if(obj.name[0].file.length>0){
                    //       chyanneedup="&needup=0";
                    //     }
                    //   }
                    // }
                    let msg=res.message;
                    let msgArray=msg.split(',');
                    that.accId=msgArray[1];
                    let qrcodetxt='/expertConfirmInfo?infoType=applybeian&accId='+that.accId+'&orgCode='+that.orgCode+'&planId='+that.planId+'&packageId='+that.packageId+'&id='+that.tableId+'&field='+obj.field;
                    let time = parseInt(new Date().getTime() / 1000);
                    obj.qrtext='http://'+this.domain+qrcodetxt+'&time='+time;
                    obj.showQrCode=true;
                    that.isSave=true;
                  }
                }).finally(() => {
                  that.confirmLoading = false;
                })
              }

            }else{
              that.$message.error("信息填写不完整,请填写必填项，然后在生成二维码");
            }
          })
        }

      },
      add() {
        this.edit({});
      },
      edit(record) {
        var that=this;
        this.form.resetFields();
        // console.log(record);
        // console.log("record.ysmoney:"+record.ysmoney);
        // if(record.ysmoney!=undefined && record.ysmoney!=null){
        //   record.zbPrice=record.zbPrice+"(验收金额:"+record.ysmoney+")";
        // }

        this.model = Object.assign({}, record);

        this.packageId = record.packageNo;
        if(record.id!=null){
          this.accId=record.id;
        }
        this.tableId = record.packageNo;
        this.orgCode=record.sysOrgCode;
        this.planId=record.planId;
        this.flowTitle=record.flowTitle==undefined?"履约验收备案申请审核":record.flowTitle;
        // this.getdownload(record.shqdFile);

        if(record.acceptanceTime!=null){
          this.enableFinshDate=true;
          this.isSave=true;
        }
        if(record.ysxzIdea=='1'){
          this.yanshouResult='合格';
        }
        else if(record.ysxzIdea=='2'){
          this.yanshouResult='基本合格';
        }
        else if(record.ysxzIdea=='3'){
          this.yanshouResult='不合格';
        }
        this.contractTime=record.contractTime;
        this.yanshou.acceptanceTime=record.acceptanceTime;
        this.ysbgNo=record.ysbgNo;
        this.yanshou.ysType=record.ysType;
        this.yanshou.supplementaryNotes=record.supplementaryNotes;
         if(this.model.ysContent== null){
          if(this.model.projectType=='服务'){
            //this.model.ysContent='根据招标合同中的服务内容、工作计划、工作规范以及服务承诺进行严格检查。'
            this.ysContentDefMsg='根据招标合同中的服务内容、工作计划、工作规范以及服务承诺进行严格检查。';
          }else if(this.model.projectType=='货物'){
            //this.model.ysContent='根据招标合同中的报价明细表和中标方提供的验收清单，严格核查品牌、产地、技术规格、数量。'
            this.ysContentDefMsg='根据招标合同中的报价明细表和中标方提供的验收清单，严格核查品牌、产地、技术规格、数量。';
          }else if(this.model.projectType=='工程'){
            //this.model.ysContent='严格对照中标方提供的工程明细进行实地验收。'
            this.ysContentDefMsg='严格对照中标方提供的工程明细进行实地验收。';
          }
        }

        this.$nextTick(() => {
          //this.form.setFieldsValue(pick(this.model,'fbMoney'))
        })
        getAction("/uaps_budget_addmainmaster/uapsBudgetAddmainmaster/selectGZQianMsgTimeByTableId",{tableid:this.accId}).then((res)=>{
          this.dwfzrqz='';
          this.lyyskyj='';
          this.zcglcfzr='';
          this.zcglcfzrqz='';
          this.zcglcfzrqzsj='';
          res=res.data;
          if(res.success){
            if(res.result){
              var listmap = res.result;
              for(var i=0;i<listmap.length;i++){
                if (listmap[i].keyName=="lyysbasqsh_zgdwfzr"){
                  this.dwfzrqz=listmap[i].realname;
                }
                if (listmap[i].keyName=="lyysbasqsh_lyysbgszrsh"){
                  this.lyyskyj =listmap[i].message;
                }
                if (listmap[i].keyName=="lyysbasqsh_zcglcfzrsh"){
                  this.zcglcfzr=listmap[i].Qian;
                  this.zcglcfzrgz=listmap[i].GZ;
                  //this.zcglcfzrqzsj=formatDate(listmap[i].submitTime,'yyyy-MM-dd');
                  this.zcglcfzrqzsj = dayjs(listmap[i].submitTime).format('YYYY-MM-DD');
                }
              }
            }
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          //that.confirmLoading = false;
        })
        // if(this.genQcode){
        //   this.SignCompleteText='签名信息未完成，无法进行后续操作,请在签名完成后再填写相关数据项';
        //   // this.confirmLoading = true;
        //   // let that=this;
        //   // setTimeout(function() {
        //   //   let isSign=that.checkSign(false);
        //   //   if (!isSign){
        //   //     that.SignCompleteText='签名信息未完成，无法进行后续操作,请在签名完成后再填写相关数据项';
        //   //   }
        //   // },2000);
        // }

        //获取签名信息
        this.getSign();
      },
      GetQueryString(name)
      {
        var a = decodeURI(window.location.search)
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = a.substr(1).match(reg);
        if(r!=null)return unescape(r[2]); return null;
      },
      getDataById(){
        if(this.genQcode==false){
          let packageId=this.GetQueryString("packageId");
          let planId=this.GetQueryString("planId");
          let sorgcode=this.GetQueryString("orgCode");
          if(packageId!=null && planId!=null){
            this.confirmLoading = true;
            getAction('/uaps_project_acceptance/uapsProjectAcceptance/queryProjectContent', {planId:planId,packageNo:packageId,orgCode:sorgcode}).then((res) => {
              res=res.data;
              if (res.success) {
                this.confirmLoading = false;
                res.result.packageNo=packageId;
                this.edit(res.result);
              }
              if (res.code === 510) {
                this.$message.warning(res.message)
              }
            })
          }

        }
      },
      removeImg(id){
        var that=this;
        deleteAction('/uaps_ele_signature/uapsEleSignature/deletemobile', {id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);

            that.sqbeian_chubuyanshou={
              name:[],
                nameNum:3,//签名个数
                phone:"",
                msg:"",
                qrtitle:"初验人员签字",
                qrtext:"",
                field:"sqbeian_chuyan",
                showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            //项目执行单位初步验收意见 项目负责人签字
            that.sqbeian_chubuyanshouFuZheRen={
              name:[],
                nameNum:1,//签名个数
                phone:"",
                msg:"",
                qrtitle:"项目负责人签字",
                qrtext:"",
                field:"sqbeian_chuyanFuZheRen",
                showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            //项目执行单位初步验收意见 单位负责人签字
            that.sqbeian_cyDanWeiFuZheRen={
              name:[],
                nameNum:1,//签名个数
                phone:"",
                msg:"",
                qrtitle:"单位负责人签字",
                qrtext:"",
                field:"sqbeian_chuyanDanWeiFuZheRen",
                showQrCodediv:false,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            //资产处负责人签字
            that.sqbeian_zichanchuFuZheRen={
              name:[],
                nameNum:1,//签名个数
                phone:"",
                msg:"",
                qrtitle:"资产处负责人签字",
                qrtext:"",
                field:"sqbeian_zichanchuFuZheRen",
                showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            //供应商签字
            that.sqbeian_GongYingShang={
              name:[],
                nameNum:1,//签名个数
                phone:"",
                msg:"",
                qrtitle:"供应商确认签字",
                qrtext:"",
                field:"sqbeian_GongYingShang",
                showQrCodediv:true,
                showQrCode:false,
                createTime:null,
                img:[]
            }
            that.getSign();

          } else {
            that.$message.warning(res.message);
          }
        });
      },
      //获取签名信息
      getSign(){
        //初验人员(需三人)签字
        this.Sign(this.sqbeian_chubuyanshou);
        //项目执行单位初步验收意见 项目负责人签字
        this.Sign(this.sqbeian_chubuyanshouFuZheRen);

        //供应商签字
        this.Sign(this.sqbeian_GongYingShang);

        if(this.flowTitle=="履约验收备案申请审核"){
          //项目执行单位初步验收意见 单位负责人签字
          this.getFlowSign(this.sqbeian_cyDanWeiFuZheRen,'主管单位负责人审核');
          //资产处负责人签字
          this.getFlowSign(this.sqbeian_zichanchuFuZheRen,'资产与实验室管理处负责人审核');
        }
        else if(this.flowTitle=="履约验收报告审核"){
          //项目执行单位初步验收意见 单位负责人签字
          this.getFlowSign(this.sqbeian_cyDanWeiFuZheRen,'履约验收科审核');
          //资产处负责人签字
          this.getFlowSign(this.sqbeian_zichanchuFuZheRen,'履约验收分管副处长审核');
        }

        //项目执行单位初步验收意见 单位负责人签字
        //this.Sign(this.sqbeian_cyDanWeiFuZheRen);
        //资产处负责人签字
        //this.Sign(this.sqbeian_zichanchuFuZheRen);
      },
      //获取手动上传签名
      getFlowSign(obj,name){
        let url="/uaps_project_acceptance/uapsProjectAcceptance/getSignByAccId";
        let params={accId:this.accId,title:this.flowTitle};
        obj.name.length=0;
        getAction(url, params).then((res) => {
          if (res.success) {
            if(res.result!=null && res.result.length>0){
              let records=res.result;
              for(let i=0;i<records.length;i++){
                if(records[i].name==name){
                  let sign={"name":records[i].name,"sign":records[i].Qian,"time":moment(records[i].submitTime).format('ll'),"GZ":records[i].GZ};
                  obj.name.push(sign);
                }
              }
              //判断是否已经签字 -1 为不限制签名个数
              if(obj.nameNum!=-1 && records.length>=obj.nameNum){
                obj.showQrCodediv=false;
              }
            }
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
        })
      },
      Sign(obj){
        let url="/uaps_ele_signature/uapsEleSignature/listmobile";
        let params={projectId:this.tableId,filedName:obj.field,accId:this.accId,sysOrgCode:this.orgCode};
        obj.name.length=0;
        getAction(url, params).then((res) => {
          res=res.data;
          if (res.success) {
            if(res.result.records.length>0){
              let records=res.result.records;
              for(let i=0;i<records.length;i++){
                let imgBase64=records[i].elSign;
                let fileJson=records[i].ysxiaozuFile;
                let filesArray=[];
                if(records[i].ysxiaozuFile!=null && records[i].ysxiaozuFile!=""){
                  let fileObj=JSON.parse(records[i].ysxiaozuFile);
                  for(let i=0;i<fileObj.length;i++){
                    filesArray.push({"fileName":fileObj[i].filename,"link":window._CONFIG['domianURL']+"/file/download?fileId="+fileObj[i].fileid})
                  }
                }
                obj.name.push({"img":imgBase64,"file":filesArray});
                obj.createTime=moment(records[i].createTime).format('ll');
                obj.phone=records[i].phone;
                obj.msg=records[i].msg;
                obj.img.push({"elSign":imgBase64,"id":records[i].id});

              }
              //判断是否已经签字 -1 为不限制签名个数
              if(obj.nameNum!=-1 && records.length>=obj.nameNum){
                obj.showQrCodediv=false;
              }
              // if(obj.field=="sqbeian_chuyan"){
              //   let isupfile=false;
              //
              //   if(obj.name.length>0){
              //     for(let j=0;j<obj.name.length;j++){
              //       if(obj.name[j].file.length>0){
              //         isupfile=true;
              //         break;
              //       }
              //     }
              //   }
              //   this.$emit('checkupfile',isupfile);
              // }
            }
            else{
              // if(obj.field=="sqbeian_chuyan"){
              //   this.$emit('checkupfile',false);
              // }
            }
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
        })
      },
      qz(data,showMsg){
        if(data.nameNum==-1){
          if(data.name.length==0){
            if(showMsg){
              this.$message.error(data.qrtitle+"不完整");
            }
            return false;
          }
        }
        else{
          if(data.name.length!=data.nameNum){
            if(showMsg){
              this.$message.error(data.qrtitle+"不完整,需要"+data.nameNum+"人签字");
            }
            return false;
          }
        }
        return true;
      },
      //判断是否签字
      checkSign(showMsg){
        //初步验收成员签字
        let cbyscy=this.qz(this.sqbeian_chubuyanshou,showMsg);

        //初步验收项目负责人签字
        let cbysxmFuZheRen=this.qz(this.sqbeian_chubuyanshouFuZheRen,showMsg);

        //供应商签字
        let gongyingshang=this.qz(this.sqbeian_GongYingShang,showMsg);

        //初步验收项目单位负责人签字
        //let cbysdwFuZheRen=this.qz(this.sqbeian_cyDanWeiFuZheRen);
        let cbysdwFuZheRen=true;

        //资产处负责人签字
        // let czcFuZheRen=this.qz(this.sqbeian_zichanchuFuZheRen);
        let czcFuZheRen=true;

        if(this.confirmLoading){
          this.confirmLoading = false;
        }
        if(cbyscy && cbysxmFuZheRen && cbysdwFuZheRen && czcFuZheRen && gongyingshang){
          return true;
        }
        return false;

        // let cyqz=this.sqbeian_chubuyanshou;
        // if(cyqz.nameNum==-1){
        //   if(cyqz.name.length==0){
        //     this.$message.error("项目执行单位初步验收意见，初验人员签字不完整");
        //     return false;
        //   }
        // }
        // else{
        //   if(cyqz.name.length!=cyqz.nameNum){
        //     this.$message.error("项目执行单位初步验收意见，初验人员签字不完整,需要"+cyqz.nameNum+"人签字");
        //     return false;
        //   }
        // }
        //
        //
        // let cyfzrqz=this.sqputong_chubuyanshouFuZheRen;
        // if(cyfzrqz.name.length!=cyfzrqz.nameNum){
        //   this.$message.error("项目执行单位初步验收意见，项目负责人签字不完整");
        //   return false;
        // }
        //
        // let cydwqz=this.sqputong_cyDanWeiFuZheRen;
        // if(cydwqz.name.length!=cydwqz.nameNum){
        //   this.$message.error("项目执行单位初步验收意见，单位负责人签字不完整");
        //   return false;
        // }
        // return true;
      },
      //渲染流程表单数据
      showFlowData() {
        if (this.formBpm === true) {
          let params = {id: this.formData.dataId};
          getAction(this.url.queryById, params).then((res) => {
            if (res.success) {
              this.edit(res.result);
            }
          });
        }
      },
      //更改验收结论性意见后触发
      reChange(){
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
              let httpurl = '';
              let method = '';
              httpurl += that.url.add;
              method = 'post';
              let formData = Object.assign(that.model, values);
              formData.isBa='1'
              formData.packageNo = that.packageId;
              formData.id=that.accId;

              httpAction(httpurl, formData, method).then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  //that.$emit('ok');
                } else {
                  let msg=res.message;
                  let msgArray=msg.split(',');
                  that.accId=msgArray[1];
                  //that.$message.error(msgArray[0]);
                }
              }).finally(() => {
                //that.confirmLoading = false;
              })
        })
      },
      submitForm() {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            var projectFinishtime = Date.parse(values.projectFinishtime);

            var acceptanceTime = Date.parse(values.acceptanceTime);
            if(acceptanceTime<projectFinishtime){
              that.$message.error("验收日期必须在完工日期之后,请查看");
            }
            if(values.ysxzIdea!='1'){
              that.$message.error("验收结论性意见 非合格 不允许发起流程");
            }
            else{
              that.confirmLoading = true;
              let httpurl = '';
              let method = '';
              httpurl += that.url.add;
              method = 'post';
              let formData = Object.assign(that.model, values);
              formData.isBa='1'
              formData.packageNo = that.packageId;
              formData.id=that.accId;

              httpAction(httpurl, formData, method).then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.$emit('ok');
                } else {
                  let msg=res.message;
                  let msgArray=msg.split(',');
                  that.accId=msgArray[1];
                  that.$message.error(msgArray[0]);
                }
              }).finally(() => {
                that.confirmLoading = false;
              })

             // if (this.checkSign(true)) {
             //    that.confirmLoading = true;
             //    let httpurl = '';
             //    let method = '';
             //    httpurl += that.url.add;
             //    method = 'post';
             //    let formData = Object.assign(that.model, values);
             //    formData.isBa='1'
             //    formData.packageNo = that.packageId;
             //    formData.id=that.accId;
             //    httpAction(httpurl, formData, method).then((res) => {
             //      if (res.success) {
             //        that.$message.success(res.message);
             //        that.$emit('ok');
             //      } else {
             //        let msg=res.message;
             //        let msgArray=msg.split(',');
             //        that.accId=msgArray[1];
             //        that.$message.error(msgArray[0]);
             //      }
             //    }).finally(() => {
             //      that.confirmLoading = false;
             //    })
             //  }
             //  else{
             //    that.$message.error("签名信息不完整,请先完成签名");
             //  }


            }

          }else{
            that.$message.error("信息填写不完整,请核对必填项");
          }
        })
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'budgetYear', 'financeProject', 'budgetDeclaretype', 'projectScope', 'gcType', 'isImport', 'budgetAddmainName', 'budgetAddmainAmount', 'contactName', 'contactPhone', 'budgetAddmainRemark', 'budgetShSchool', 'budgetSpZcb', 'budgetSpCaiwu', 'budgetSpGov', 'budgetMainAmountpifu', 'budgetBuyType', 'budgetAgencyCompanyid', 'budgetAgencyCompany', 'processId', 'limitTime', 'safeTime', 'parameterFile', 'parameterContent', 'isInplan', 'planId', 'backReason', 'isCslz', 'masterId', 'agreementBTime', 'agreementETime','fbMoney'))
      },
      getAvatarView: function (avatar) {
        //return getFileAccessHttpUrl(avatar)
      },
      getdownload(fileIds) {
        if (fileIds != "" && fileIds != null) {
          let sqsjData = JSON.parse(fileIds);
          this.fileIds = [];
          for (let i = 0; i < sqsjData.length; i++) {
            this.fileIds.push(sqsjData[i]);
          }
        }
      },
      download(fileName, id) {
        downloadFile('/file/download/', fileName, {fileId: id});
      },
      deleteAction(id) {
        this.fileIds.splice(this.fileIds.findIndex(e => e.fileid == id), 1)
      },
    }
  }
</script>
<style scoped>
  .inputclass {
    border: none;
    outline: none
  }

  p.MsoNormal {
    mso-style-name: 正文;
    mso-style-parent: "";
    margin: 0pt;
    margin-bottom: .0001pt;
    font-family: 'Times New Roman';
    mso-fareast-font-family: 宋体;
    font-size: 10.0000pt;
  }

  span

  .10
  {
    font-family: 等线
  ;
  }

  span

  .15
  {
    font-family: 等线
  ;
    font-size: 9.0000pt
  ;
  }

  span

  .16
  {
    font-family: 等线
  ;
    font-size: 9.0000pt
  ;
  }
  p{
    margin-bottom: 0px !important;
  }
  p.MsoHeader {
    mso-style-name: 页眉;
    mso-style-noshow: yes;
    margin: 0pt;
    margin-bottom: .0001pt;
    border-bottom: 1.0000pt solid windowtext;
    mso-border-bottom-alt: 0.7500pt solid windowtext;
    padding: 0pt 0pt 1pt 0pt;
    layout-grid-mode: char;
    mso-pagination: none;
    text-align: center;
    font-family: 等线;
    mso-bidi-font-family: 'Times New Roman';
    font-size: 9.0000pt;
    mso-font-kerning: 1.0000pt;
  }

  p.MsoFooter {
    mso-style-name: 页脚;
    mso-style-noshow: yes;
    margin: 0pt;
    margin-bottom: .0001pt;
    layout-grid-mode: char;
    mso-pagination: none;
    font-family: 等线;
    mso-bidi-font-family: 'Times New Roman';
    font-size: 9.0000pt;
    mso-font-kerning: 1.0000pt;
  }

  span.msoIns {
    mso-style-type: export-only;
    mso-style-name: "";
    text-decoration: underline;
    text-underline: single;
    color: blue;
  }

  span.msoDel {
    mso-style-type: export-only;
    mso-style-name: "";
    text-decoration: line-through;
    color: red;
  }

  table.MsoNormalTable {
    mso-style-name: 普通表格;
    mso-style-parent: "";
    mso-style-noshow: yes;
    mso-tstyle-rowband-size: 0;
    mso-tstyle-colband-size: 0;
    mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
    mso-para-margin: 0pt;
    mso-para-margin-bottom: .0001pt;
    mso-pagination: widow-orphan;
    font-family: 'Times New Roman';
    font-size: 10.0000pt;
    mso-ansi-language: #0400;
    mso-fareast-language: #0400;
    mso-bidi-language: #0400;
  }

  @page {
    mso-page-border-surround-header: no;
    mso-page-border-surround-footer: no;
  }

  @page Section0 {
    margin-top: 72.0000pt;
    margin-bottom: 72.0000pt;
    margin-left: 90.0000pt;
    margin-right: 90.0000pt;
    size: 595.3000pt 841.9000pt;
    layout-grid: 15.6000pt;
  }

  div.Section0 {
    page: Section0;
  }
  .shurukuang{
    border: none !important;
    resize:none;
    text-align: center;
    background-color: #FFFFFF;
  }
  .ant-input-disabled {
    background-color: #fff !important;
    color: #000 !important;
  }
.sign{
  /*height: 50px;*/
  /*font-size: 20px;*/
}
  .image-container {
    position: relative;
    display: inline-block;
  }

  .delete-button {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: #cacaca;
    color: #000000;
    font-size: 12px;
    padding: 5px;
    cursor: pointer;
    user-select: none;
  }

  .image-container:hover .delete-button {
    display: block;
  }
</style>
